"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const PaypalIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M14 6.694c0 .313-.039.632-.101.949-.509 2.578-2.248 3.468-4.47 3.468h-.343a.549.549 0 00-.545.46l-.482 2.97a.55.55 0 01-.544.459H5.873a.374.374 0 01-.377-.427l.832-5.18.037-.033h1.293c3.141 0 5.105-1.527 5.684-4.414.487.474.658 1.094.658 1.748zm-8.53 2.48c.07-.482.276-.686.831-.688h1.356c2.745 0 4.32-1.22 4.814-3.728C12.951 2.346 11.21 1 8.853 1H4.446a.628.628 0 00-.623.526C2.441 10.179 2.041 12.38 2.001 13.05a.376.376 0 00.38.392h2.394l.695-4.269z"
  })))
});
PaypalIcon.displayName = 'PaypalIcon';
var _default = exports.default = PaypalIcon;